import React from "react";
import styled from "styled-components";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

export default function CartWidget() {
  const { items, total, setQuantity, removeItem, clear } = useCart();
  const navigate = useNavigate();

    if (items.length === 0) return null;

  return (
    <Widget>
      <Header>
        <div>Cart</div>
        <div style={{ fontWeight: 700 }}>{items.length}</div>
      </Header>

      <Body>
        {items.length === 0 ? (
          <Empty>No items</Empty>
        ) : (
          items.map((it) => (
            <Row key={it.srvId}>
              <div style={{ flex: 1, minWidth: 120 }}>
                <div style={{ fontWeight: 700 }}>{it.name}</div>
                <div style={{ fontSize: 12 }}>KES {Number(it.price || 0).toLocaleString()}</div>
              </div>

              <Qty>
                <button onClick={() => setQuantity(it.srvId, (Number(it.quantity) || 0) - 1)}>-</button>
                <input type="number" value={it.quantity} onChange={(e) => setQuantity(it.srvId, e.target.value)} />
                <button onClick={() => setQuantity(it.srvId, (Number(it.quantity) || 0) + 1)}>+</button>
              </Qty>

              <Remove>
                <button onClick={() => removeItem(it.srvId)}>✕</button>
              </Remove>
            </Row>
          ))
        )}
      </Body>

      <Footer>
        <div style={{ fontWeight: 700 }}>Total: KES {Number(total || 0).toLocaleString()}</div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="outline" onClick={() => { clear(); }}>Clear</button>
          <button onClick={() => navigate("/checkout")} disabled={items.length === 0}>Checkout</button>
        </div>
      </Footer>
    </Widget>
  );
}

const Widget = styled.div`
  position: fixed;
  right: 18px;
  bottom: 18px;
  width: 320px;
  max-width: calc(100% - 36px);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 30px rgba(18,24,64,0.12);
  overflow: hidden;
  z-index: 20000;
  display: flex;
  flex-direction: column;
  font-family: inherit;
`;

const Header = styled.div`
  padding: 10px 12px;
  display:flex;
  justify-content:space-between;
  border-bottom:1px solid #f3f4f8;
  font-weight:700;
`;

const Body = styled.div`
  max-height: 260px;
  overflow:auto;
  padding: 8px;
`;

const Empty = styled.div`
  padding: 12px;
  color:#666;
`;

const Row = styled.div`
  display:flex;
  align-items:center;
  gap:8px;
  padding:8px 0;
  border-bottom:1px dashed #f1f2f6;
`;

const Qty = styled.div`
  display:flex;
  align-items:center;
  gap:6px;
  button { padding:6px 8px; border-radius:6px; border:1px solid #eee; background:#fff; cursor:pointer; }
  input { width:46px; text-align:center; padding:6px; border-radius:6px; border:1px solid #eee; }
`;

const Remove = styled.div`
  button { background:transparent; border:0; cursor:pointer; color:#b32424; font-size:14px; }
`;

const Footer = styled.div`
  padding:8px 12px;
  border-top:1px solid #f3f4f8;
  display:flex;
  align-items:center;
  justify-content:space-between;

  button { padding:8px 10px; border-radius:8px; border:0; background:linear-gradient(180deg,#6a2cff,#5a22c9); color:#fff; cursor:pointer; }
  button.outline { background:#fff; border:1px solid #e9e9f4; color:#222; }
`;
